let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("vyt3u")).then(() => parcelRequire('d4W8d'));